var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u516C\u53F8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-163.000000, -1462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u516C\\u53F8",
    transform: "translate(163.000000, 1462.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89127753,1.5 C9.98611514,1.5 10.8736564,2.38754124 10.8736564,3.48237885 L10.8736564,5.04132159 L12.3802643,5.04132159 C13.4751019,5.04132159 14.3626432,5.92886283 14.3626432,7.02370044 L14.3626432,13.5385903 L14.6449339,13.5385903 C14.9514885,13.5385903 15.2,13.7871019 15.2,14.0936564 C15.2,14.4002109 14.9514885,14.6487225 14.6449339,14.6487225 L1.35506608,14.6487225 C1.04851155,14.6487225 0.8,14.4002109 0.8,14.0936564 C0.8,13.7871019 1.04851155,13.5385903 1.35506608,13.5385903 L1.86493392,13.5385903 L1.86493392,3.48237885 C1.86493392,2.38754124 2.75247517,1.5 3.84731278,1.5 Z M12.3802643,6.15462555 L10.8736564,6.15462555 L10.8736564,13.5417621 L13.252511,13.5417621 L13.252511,7.02687225 C13.252511,6.5451437 12.8619929,6.15462555 12.3802643,6.15462555 Z M8.89762115,2.61013216 L3.85048458,2.61013216 C3.36875603,2.61013216 2.97823789,3.00065031 2.97823789,3.48237885 L2.97823789,13.5385903 L9.76986784,13.5385903 L9.76986784,3.48237885 C9.76986784,3.00065031 9.37934969,2.61013216 8.89762115,2.61013216 Z M8.00396476,7.96334802 C8.31051929,7.96334802 8.55903084,8.21185957 8.55903084,8.5184141 C8.55903084,8.82496863 8.31051929,9.07348018 8.00396476,9.07348018 L4.88052863,9.07348018 C4.5739741,9.07348018 4.32546256,8.82496863 4.32546256,8.5184141 C4.32546256,8.21185957 4.5739741,7.96334802 4.88052863,7.96334802 Z M8.00396476,5.04449339 C8.31051929,5.04449339 8.55903084,5.29300494 8.55903084,5.59955947 C8.55903084,5.906114 8.31051929,6.15462555 8.00396476,6.15462555 L4.88052863,6.15462555 C4.5739741,6.15462555 4.32546256,5.906114 4.32546256,5.59955947 C4.32546256,5.29300494 4.5739741,5.04449339 4.88052863,5.04449339 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#575C62",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/公司.795ca38ab6df91202431efeaa2d59673.svg";
export { ForwardRef as ReactComponent };